'use client'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { ActiveWearContainer } from './container'

export const ActiveWearShowcase = () => {
  const t = useTranslations()
  const womenCollections = [
    {
      image: '/image/March2025/mceclip26.jpg',
      subtitle: t('coolmate_activewear_nu.showcase.yoga.subtitle'),
      title: t('coolmate_activewear_nu.showcase.yoga.title'),
      link: '/collection/yoga-pilates',
    },
    {
      image: '/image/March2025/mceclip27.jpg',
      subtitle: t('coolmate_activewear_nu.showcase.running.subtitle'),
      title: t('coolmate_activewear_nu.showcase.running.title'),
      link: '/collection/quan-ao-chay-bo-nu',
    },
    {
      image: '/image/March2025/mceclip28.jpg',
      subtitle: t('coolmate_activewear_nu.showcase.sportwear.subtitle'),
      title: t('coolmate_activewear_nu.showcase.sportwear.title'),
      link: '/collection/the-thao-chung-nu',
    },
    // [
    //     'image' => '/image/March2025/mceclip29.jpg',
    //     'subtitle' => 'Coming soon',
    //     'title' => 'PICKLEBALL',
    //     'link' => '',
    // ]
  ]

  return (
    <ActiveWearContainer className='no-scrollbar mx-4 my-6 flex items-center gap-4 overflow-auto px-0 py-0 md:my-12 md:justify-center'>
      {womenCollections.map((item) => (
        <Link
          key={item.image}
          href={item.link}
          className='group relative block flex-none basis-2/3 cursor-pointer overflow-hidden rounded-2xl md:basis-1/3 xl:basis-1/4'
        >
          <Image
            src={ImageHelper.getImageUrl(item.image)}
            alt={item.title}
            width={274}
            height={366}
            className='aspect-[3/4] w-full transform object-cover duration-500 group-hover:scale-105'
          />
          <div className='absolute bottom-0 left-0 flex h-full w-full flex-col justify-end bg-gradient-to-t from-black/30 to-transparent pb-6 text-center text-light'>
            <p className='mb-1 font-criteria text-sm leading-5'>
              {item.subtitle}
            </p>
            <p className='font-criteria text-xl font-medium uppercase leading-7'>
              {item.title}
            </p>
          </div>
        </Link>
      ))}
    </ActiveWearContainer>
  )
}
